import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';
import { fieldHelp } from '../../lib/fieldHelp';

/** A labelled form field with the same hover explanation the ticket forms
 *  use: the label looks up its own help text, so every CRM field explains
 *  itself just by being labelled. */
export default function Field({ label, children, required, hint }: { label: string; children: ReactNode; required?: boolean; hint?: string }) {
  const help = fieldHelp(label);
  return (
    <div>
      <label className="block text-xs font-medium text-muted mb-1.5 uppercase tracking-wide" title={help}>
        {label}{required && <span className="text-err ml-0.5">*</span>}
        {help && <HelpCircle className="w-3 h-3 inline-block ml-1 -mt-0.5 opacity-50" aria-hidden />}
      </label>
      {children}
      {hint && <p className="text-xs text-muted mt-1">{hint}</p>}
    </div>
  );
}
